<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
  <span
    class="modal-title h4"
    translate="main.modals.2faclientExpiration.{{ label }}.title"
    *ngIf="label !== 'renew'"
  ></span>
  <span
    class="modal-title h4"
    translate="main.modals.2faclientExpiration.maxRenew.title"
    *ngIf="label === 'renew'"
  ></span>
  <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="activeModal.dismiss('closed')">
    <span aria-hidden="true">{{ 'main.charX' | translate }}</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="row g-0 py-3 mb-3" [ngClass]="bgClass">
        <div class="col-2 col-sm-1 text-center ps-3">
          <svg-icon src="{{ svgSrc }}" [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'top' }">
          </svg-icon>
        </div>
        <div class="col-10 col-sm-11 text-start ps-3 pe-2" *ngIf="label === 'renew'">
          <span
            [innerHTML]="'main.modals.2faclientExpiration.maxRenew.alert' | translate : { expireDate: expirationDate }"
          >
          </span>
        </div>
        <div class="col-10 col-sm-11 text-start ps-3 pe-2" *ngIf="label === 'nearly'">
          <span
            [innerHTML]="'main.modals.2faclientExpiration.nearly.alert' | translate : { expireDate: expirationDate }"
          ></span>
        </div>
        <div class="col-10 col-sm-11 text-start ps-3 pe-2" *ngIf="label === 'expired'">
          <span
            [innerHTML]="'main.modals.2faclientExpiration.expired.alert' | translate : { expireDate: expirationDate }"
          ></span>
        </div>
      </div>
    </div>
    <div
      class="col-md-12 mb-0"
      [innerHTML]="'main.modals.2faclientExpiration.maxRenew.description' | translate"
      *ngIf="label === 'renew'"
    ></div>
    <div
      class="col-md-12 mb-0"
      [innerHTML]="'main.modals.2faclientExpiration.nearly.description' | translate"
      *ngIf="label === 'nearly'"
    ></div>
    <div
      class="col-md-12 mb-0"
      [innerHTML]="'main.modals.2faclientExpiration.expired.description' | translate"
      *ngIf="label === 'expired'"
    ></div>
  </div>
</div>
<div class="modal-footer justify-content-start">
  <button
    type="submit"
    class="btn btn-lg btn-primary"
    [innerHTML]="'main.modals.2faclientExpiration.maxRenew.btnChangeClient' | translate"
    *ngIf="label === 'renew'"
    (click)="hideAdvise()"
  >
    Invia codice per email
  </button>
  <button
    type="submit"
    class="btn btn-lg btn-primary"
    [innerHTML]="'main.modals.2faclientExpiration.nearly.btnChangeClient' | translate"
    *ngIf="label === 'nearly'"
    (click)="hideAdvise()"
  >
    Invia codice per email
  </button>
  <button
    type="submit"
    class="btn btn-lg btn-primary"
    [innerHTML]="'main.modals.2faclientExpiration.expired.btnChangeClient' | translate"
    *ngIf="label === 'expired'"
    (click)="hideAdvise()"
  >
    Invia codice per email
  </button>
  <button
    type="button"
    class="btn btn-link"
    (click)="activeModal.dismiss('closed')"
    translate="main.modals.2faclientExpiration.{{ label }}.btnCancel"
    *ngIf="label !== 'renew'"
  ></button>
  <button
    type="button"
    class="btn btn-link"
    (click)="activeModal.dismiss('closed')"
    translate="main.modals.2faclientExpiration.maxRenew.btnCancel"
    *ngIf="label === 'renew'"
  ></button>
</div>
